<template>
	<div class="small-12 addForm addResident animated fadeInRightBig border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
		<div class="small-12 columns panelMenuWrapper">
			<div class="small-12 formTitle border-bottom">
				<h2 class="small-12 flex vertical-align vertical-align justify-between">
					<span class="float-left small-8">
						Create a Unit
					</span>
					<i class="material-icons-outlined transition" @click="closeMenu()">cancel</i>
				</h2>
				<div class="small-12" v-if="property">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p v-if="property.attributes.title">
								<b>For: </b>
								{{ property.attributes.title }}
							</p>
							<p v-else>
								<b>For: </b>
								{{ property.attributes.address.street_1 }}
							</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="small-12 formBody" v-if="property">
				<div class="small-12 image borderRadius8">
					<picture class="flex small-12 justify-center vertical-align">
						<img :src="vector_image" style="width:50%" alt="A Unit with a Ton of Rooms">
					</picture>
				</div>
				<div class="small-12 sectionTitle flex first">
					<h2>Unit Number</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Unit Number<em class="cRed">*</em></label>
					<input type="text" placeholder="e.g. 301-B or 124" v-model="new_unit.attributes.number" @input="unitNumberValidation()">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="unit_number.error">
						<small class="cRed small-12">{{unit_number.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Market Rent</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Market Rent (Dollars)</label>
					<div class="small-12 addOnContainer borderRadius8">
						<input type="number" min="1" max="1000000000" step="1" placeholder="e.g. 1,200" class="inputAddition" v-model="new_unit.attributes.rent.market" @input="enableSubmitButtonCheck()">
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="market_rent.error">
						<small class="cRed small-12">{{market_rent.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Listing Information</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Size (Square Feet)<em class="cRed">*</em></label>
					<input type="number" placeholder="e.g. 900" min="1" max="1000000000" step="1" v-model="new_unit.attributes.square_feet" @input="sizeValidation()">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="size.error">
						<small class="cRed small-12">{{size.title}}</small>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12 bedBath flex vertical-align">
						<div class="small-5">
							<label class="small-12">Bedrooms<em class="cRed">*</em></label>
							<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="unit_options">
								<select name="units" class="small-12" v-model="new_unit.attributes.bedrooms" @change="enableSubmitButtonCheck()">
									<option :value="null" selected disabled>Please Choose...</option>
									<option :value="roomOption.value" v-for="(roomOption, roomOptionIndex) in unit_options.bedroom_options" :key="roomOptionIndex" :selected="new_unit.attributes.bedrooms == roomOption.value ? true : false">{{roomOption.title}}</option>
								</select>
							</div>
							<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="bedrooms.error">
								<small class="cRed small-12">{{bedrooms.title}}</small>
							</div>
						</div>
						<div class="small-2 columns flex justify-center vertical-align">
							<span class="formSymbol border borderRadius4 flex vertical-align justify-center">/</span>
						</div>
						<div class="small-5">
							<label class="small-12">Bathrooms<em class="cRed">*</em></label>
							<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="unit_options">
								<select name="units" class="small-12" v-model="new_unit.attributes.bathrooms" @change="enableSubmitButtonCheck()">
									<option :value="null" selected disabled>Please Choose...</option>
									<option :value="roomOption.value" v-for="(roomOption, roomOptionIndex) in unit_options.bathroom_options" :key="roomOptionIndex" :selected="new_unit.attributes.bathrooms == roomOption.value ? true : false">{{roomOption.title}}</option>
								</select>
							</div>
							<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="bathrooms.error">
								<small class="cRed small-12">{{bathrooms.title}}</small>
							</div>
						</div>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Description</label>
					<textarea name="description" id="description" class="borderRadius8 description" v-model="new_unit.attributes.description" @input="enableSubmitButtonCheck()"></textarea>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Features</label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="unit_options">
						<select name="features" class="small-12" v-model="chosen_feature" @change="addFeature($event)">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="featureOption.value" v-for="(featureOption, featureOptionIndex) in unit_options.features_options" :key="featureOptionIndex">{{featureOption.title}}</option>
						</select>
					</div>
					<div class="small-12 features animated fadeIn" v-if="new_unit.attributes.features.length > 0">
						<div class="auto animated fadeIn" v-for="(feature, index) in new_unit.attributes.features" :key="index">
							<a class="tag flex vertical-align justify-center borderRadius4" @click="removeFeature(index)">
								{{feature.title}}
								<i class="material-icons-outlined borderRadius4 flex justify-center vertical-align">cancel</i>
							</a>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Unit Address</h2>
				</div>
				<fieldset class="small-12">
					<div class="small-12 large-3 toggle-button">
						<toggle-button v-model="show_address" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
					</div>
					<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
						<p class="small-12 columns"><b>Different Address</b></p>
						<span class="small-12 columns">Does this unit have a different address than the property?</span>
					</div>
				</fieldset>
				<fieldset class="flex small-12 address animated fadeIn" v-if="show_address">
					<label class="small-12">Street<em class="cRed">*</em></label>
					<input type="text" name="street_1" v-model="new_unit.attributes.address.street_1">
					<input type="text" name="street_2" v-model="new_unit.attributes.address.street_2">
					<label class="small-12">City<em class="cRed">*</em></label>
					<input type="text" name="city" v-model="new_unit.attributes.address.city">
					<label class="small-12">State<em class="cRed">*</em></label>
					<div class="small-12 columns selectContainer borderRadius8" v-if="states_options">
						<select class="small-12 columns" name="state" v-model="new_unit.attributes.address.state">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="state.abbreviation" v-for="(state, stateIndex) in states_options.options" :key="stateIndex" :selected="new_unit.attributes.address.state == state.abbreviation ? true : false">{{state.abbreviation}}</option>
						</select>
					</div>
					<label class="small-12">Zip Code<em class="cRed">*</em></label>
					<input type="text" name="zip_code" v-model="new_unit.attributes.address.zip_code">
				</fieldset>
			</div>
		</div>
		<div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton small-12 flex borderRadius8 vertical-align" @click="createTheUnit()" style="max-width:155px;" v-if="enableCreateButton">
				<i class="material-icons flex vertical-align justify-center">save</i>
				Create Unit
			</a>
			<a class="disabledButton small-12 flex borderRadius8 vertical-align" style="max-width:155px;" v-else>
				<i class="material-icons flex vertical-align justify-center">save</i>
				Create Unit
			</a>
		</div>
	</div>
</template>

<script>

	// Import the repository
	import { UnitsRepository } from '@/repositories/units/UnitsRepository'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { Autogrow } from '@/mixins/helpers/Autogrow'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

	// Import the events
	import { GetStatesOptions } from '@/events/config/GetStatesOptions'
	import { GetUnitOptions } from '@/events/config/GetUnitOptions'
	import { CreateUnit } from '@/events/units/CreateUnit'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'AddUnitMenu',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			UnitsRepository,
			Autogrow,
			SpinnerMethods,
			GetStatesOptions,
			GetUnitOptions,
			CreateUnit

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
			},
			property: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			open_menu: false,
			show_address: false,
			vector_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Funit-rooms.svg?alt=media&token=e25a6064-56ce-4014-9488-e4d145a2734a',
			chosen_feature: null,
			units_total: 0,
			enableCreateButton: false,
			unit_number: {
				error: false,
				title: null
			},
			market_rent: {
				error: false,
				title: null
			},
			size: {
				error: false,
				title: null
			},
			bedrooms: {
				error: false,
				title: null
			},
			bathrooms: {
				error: false,
				title: null
			}

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.open_menu = true;

				}

			},

			property: {

				immediate: true, // Load on created
				handler(property) {

					if (property) {

						/*
						**  Set the address
						**  @method: @here
						*/

						this.setAddress();

					}

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

			/*
			**  Set autogrow for textareas
			**  @helper: @Mixins/Helpers/Autogrow
			*/

        	this.autogrowInit();

			/*
			**  Get the states config
			**  @helper: @Events/Config/GetStatesOptions
			*/

        	this.getStatesOptionsHandler();

			/*
			**  Get the units config
			**  @helper: @Events/Config/GetUnitOptions
			*/

        	this.getUnitOptionsHandler();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			closeMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.open_menu = false;
 
					/*
					**  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeAddUnitMenu', true);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Close the add unit menu.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: '1cJNJwSfilsAMP6VZJHO',
						error: e
					});

				}

			},

			setAddress: function() {

				try {

					/*
					**  Set the props
					**  @props: @here
					*/

					this.new_unit.attributes.address.street_1 = this.property.attributes.address.street_1;
					this.new_unit.attributes.address.city = this.property.attributes.address.city;
					this.new_unit.attributes.address.state = this.property.attributes.address.state;
					this.new_unit.attributes.address.zip_code = this.property.attributes.address.zip_code;

					/*
					**  Set the property ID
					**  @prop: @here
					*/

					this.new_unit.relationships.property = this.property.id;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Set the form props.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: '86YRglBRgb4En9QCLBeD',
						error: e
					});

				}

			},

			addFeature: function(event) {

				try {

					/*
					**  Remove the underscores
					*/

					let selectOptionValue = event.target.value.replace(/_/g, " ");
 
					/*
					**  Set the vars
					*/

					let eventArray = selectOptionValue.split(' ');
					let tempArray = [];
 
					/*
					**  Uppercase em'
					*/

					for(var x = 0; x < eventArray.length; x++){

						tempArray.push(eventArray[x].charAt(0).toUpperCase()+eventArray[x].slice(1));
					}
 
					/*
					**  Reset
					*/

					selectOptionValue = tempArray.join(' ');

					/*
					**  Convert to object
					*/

					let selectedOption = {
						title: selectOptionValue,
						value: event.target.value
					};
 
					/*
					**  Verify if already chosen
					*/

					let existing_feature =  this.new_unit.attributes.features.filter(function(feature) {

						return feature.value == event.target.value;

					});
 
					/*
					**  If exists, show message
					*/

					if (existing_feature.length > 0) {

						this.$swal('Uh Oh!', 'The feature you have selected has already been chosen.', 'error');

						return;

					}

					/*
					**  Add to features prop
					*/

					this.new_unit.attributes.features.push(selectedOption);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Add a selected feature.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: 'gCgNMNpsLpOppwkZqNvV',
						error: e
					});

				}

			},

			removeFeature: function(index) {

				try {

					/*
					**  Remove feature from prop
					*/

					if (index > -1) this.new_unit.attributes.features.splice(index, 1);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Remove a feature for a unit.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: 'AvtWDwoGzxZYfwGfyA52',
						error: e
					});

				}

			},

			unitNumberValidation: function () {

				try {

					/*
					**  Validate
					**  @props: @here
					*/

                    if (this.new_unit.attributes.number == '' || !this.new_unit.attributes.number || this.new_unit.attributes.number.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit_number.error = true;
                        this.unit_number.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit_number.error = false;
                        this.unit_number.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Unit Number Validation Failed.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: 'u9J0eF2gFNuVefmP8mf9',
						error: e
					});

				}

			},

			sizeValidation: function() {

				try {

					/*
					**  Validate
					**  @props: @here
					*/

                    if (this.new_unit.attributes.square_feet == '' || !this.new_unit.attributes.square_feet || this.new_unit.attributes.square_feet.length == 0 || this.new_unit.attributes.square_feet == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.size.error = true;
                        this.size.title = 'This is a required field and must be greater than 0.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.size.error = false;
                        this.size.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Unit Size Validation Failed.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: '41JOJF7oBI4nbrV5e5CD',
						error: e
					});

				}

			},

			enableSubmitButtonCheck: function() {

				try {

					/*
					**  Can we enable the submit button?
					**  @props: @here
					*/

					if (this.new_unit.attributes.square_feet !== 0 && this.new_unit.attributes.bedrooms && this.new_unit.attributes.bathrooms && !this.unit_number.error && !this.size.error) {

                        /*
						**  Enable the create button
						**  @prop: @here
						*/

						this.enableCreateButton = true;

						return;

					}

					/*
					**  Disable the create button
					**  @prop: @here
					*/

					this.enableCreateButton = false;

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to perform submit button check.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: 'NV0foVUTwHjiQsqpL0fn',
						error: e
					});

                }

			},

			createTheUnit: function() {

				try {

					/*
					**  Validate
					**  @method: @here
					*/

					let validated = this.validate();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please fill out all required fields before creating a new unit.', 'error');

						return;

					}

					/*
					**  Create the unit
					**  @method: @here
					*/

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to create the unit.',
						errorType: 'Application',
						section: 'Add Unit Menu',
						uid: 'nOp3K0i0upOS9ApqVT0m',
						error: e
					});

				}

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>